// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CorrectiveMaintenanceStatusDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class CorrectiveMaintenanceStatusApiClient extends BaseCRUDApiClient<CorrectiveMaintenanceStatusDto> {
  baseUrl = this.config.apiEndpoint + '/corrective-maintenance-status';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
